import { render } from "./VenatusAd.vue?vue&type=template&id=169712f8&scoped=true"
import script from "./VenatusAd.vue?vue&type=script&lang=ts"
export * from "./VenatusAd.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-169712f8"

export default script